// Author Liu Cui Cui
// Date 2024-12-31 13:43:55

class SithMesQualityDocument {
    constructor({
                    id = null,
                    projectId = '',
                    projectCode = '',
                    uploadTime = '',
                    uploader = '',
                    qualityAttachment = '',
                    orderCode = '',
                    poNumber = '',
                    itemNumber = '',
                    materialCode = '',
                    materialName = '',
                    materialDesc = '',
                    vendorCode = '',
                    vendorNameZh = '',
                    vendorNameEn = '',
                    purchaser = '',
                    remark = '',
                    qualityFileIds = '',
                    qualityAttachmentList = '',
                    qualityFiles = ''
                }
                = {}) {
        this.id = id;
        this.projectId = projectId;
        this.projectCode = projectCode;
        this.uploadTime = uploadTime;
        this.uploader = uploader;
        this.qualityAttachment = qualityAttachment;
        this.orderCode = orderCode;
        this.poNumber = poNumber;
        this.itemNumber = itemNumber;
        this.materialCode = materialCode;
        this.materialName = materialName;
        this.materialDesc = materialDesc;
        this.vendorCode = vendorCode;
        this.vendorNameZh = vendorNameZh;
        this.vendorNameEn = vendorNameEn;
        this.purchaser = purchaser;
        this.remark = remark;
        this.qualityFileIds = qualityFileIds;
        this.qualityAttachmentList = qualityAttachmentList;
        this.qualityFiles = qualityFiles;
    }
}

function newEntity() {
    return new SithMesQualityDocument();
}

function gridFields() {
    return Object.freeze([
        {
            key: 'id',
            label: 'label.sith.quality.sithMesQualityDocument.grid.id',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'projectId',
            label: 'label.sith.quality.sithMesQualityDocument.grid.projectId',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'projectCode',
            label: 'label.sith.quality.sithMesQualityDocument.grid.projectCode',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'uploadTime',
            label: 'label.sith.quality.sithMesQualityDocument.grid.uploadTime',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'uploader',
            label: 'label.sith.quality.sithMesQualityDocument.grid.uploader',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'qualityAttachmentList',
            label: 'label.sith.quality.sithMesQualityDocument.grid.qualityAttachmentList',
            sortable: true,
            isDetail: true,
            form: {
                type: 'emAttachment',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'orderCode',
            label: 'label.sith.quality.sithMesQualityDocument.grid.orderCode',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'poNumber',
            label: 'label.sith.quality.sithMesQualityDocument.grid.poNumber',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'itemNumber',
            label: 'label.sith.quality.sithMesQualityDocument.grid.itemNumber',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'materialCode',
            label: 'label.sith.quality.sithMesQualityDocument.grid.materialCode',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'materialName',
            label: 'label.sith.quality.sithMesQualityDocument.grid.materialName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'materialDesc',
            label: 'label.sith.quality.sithMesQualityDocument.grid.materialDesc',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'vendorCode',
            label: 'label.sith.quality.sithMesQualityDocument.grid.vendorCode',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'vendorNameZh',
            label: 'label.sith.quality.sithMesQualityDocument.grid.vendorNameZh',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'vendorNameEn',
            label: 'label.sith.quality.sithMesQualityDocument.grid.vendorNameEn',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'purchaser',
            label: 'label.sith.quality.sithMesQualityDocument.grid.purchaser',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'remark',
            label: 'label.sith.quality.sithMesQualityDocument.grid.remark',
            sortable: true,
            isDetail: true,
            form: {
                type: 'textarea',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'qualityFiles',
            label: 'label.sith.quality.sithMesQualityDocument.grid.qualityFiles',
            sortable: true,
            isDetail: true,
            form: {
                type: 'emAttachment',
                modalMultiSelectedType: 'string'
            }
        }
    ])
}

const filter = {
    idFilter: '',
    idListFilter: [],
    projectIdFilter: '',
    projectCodeFilter: '',
    orderCodeFilter: '',
    poNumberFilter: '',
    itemNumberFilter: '',
    materialCodeFilter: '',
    materialNameFilter: '',
    materialDescFilter: '',
    vendorCodeFilter: '',
    vendorNameZhFilter: '',
    vendorNameEnFilter: '',
    purchaserFilter: ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
    {
        key: 'projectIdFilter',
        label: 'label.sith.quality.sithMesQualityDocument.filter.projectId',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectCodeFilter',
        label: 'label.sith.quality.sithMesQualityDocument.filter.projectCode',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesPrdProjectInfo'
            , correspondingField: 'projectCode'
            , fieldsBindingByEntityModalSelected: '{"projectId":"id"}'
        }
    },
    {
        key: 'orderCodeFilter',
        label: 'label.sith.quality.sithMesQualityDocument.filter.orderCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'poNumberFilter',
        label: 'label.sith.quality.sithMesQualityDocument.filter.poNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'itemNumberFilter',
        label: 'label.sith.quality.sithMesQualityDocument.filter.itemNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialCodeFilter',
        label: 'label.sith.quality.sithMesQualityDocument.filter.materialCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialNameFilter',
        label: 'label.sith.quality.sithMesQualityDocument.filter.materialName',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialDescFilter',
        label: 'label.sith.quality.sithMesQualityDocument.filter.materialDesc',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'vendorCodeFilter',
        label: 'label.sith.quality.sithMesQualityDocument.filter.vendorCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'vendorNameZhFilter',
        label: 'label.sith.quality.sithMesQualityDocument.filter.vendorNameZh',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'vendorNameEnFilter',
        label: 'label.sith.quality.sithMesQualityDocument.filter.vendorNameEn',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purchaserFilter',
        label: 'label.sith.quality.sithMesQualityDocument.filter.purchaser',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    }
];


const entityFormConfigs = [
    {
        key: 'projectId',
        label: 'label.sith.quality.sithMesQualityDocument.entity.projectId',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectCode',
        label: 'label.sith.quality.sithMesQualityDocument.entity.projectCode',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesPrdProjectInfo'
            , correspondingField: 'projectCode'
            , fieldsBindingByEntityModalSelected: '{"projectId":"id"}'
        }
    },
    {
        key: 'uploadTime',
        label: 'label.sith.quality.sithMesQualityDocument.entity.uploadTime',
        sortable: true,
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'uploader',
        label: 'label.sith.quality.sithMesQualityDocument.entity.uploader',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'orderCode',
        label: 'label.sith.quality.sithMesQualityDocument.entity.orderCode',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'poNumber',
        label: 'label.sith.quality.sithMesQualityDocument.entity.poNumber',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'itemNumber',
        label: 'label.sith.quality.sithMesQualityDocument.entity.itemNumber',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialCode',
        label: 'label.sith.quality.sithMesQualityDocument.entity.materialCode',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialName',
        label: 'label.sith.quality.sithMesQualityDocument.entity.materialName',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialDesc',
        label: 'label.sith.quality.sithMesQualityDocument.entity.materialDesc',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'vendorCode',
        label: 'label.sith.quality.sithMesQualityDocument.entity.vendorCode',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'vendorNameZh',
        label: 'label.sith.quality.sithMesQualityDocument.entity.vendorNameZh',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'vendorNameEn',
        label: 'label.sith.quality.sithMesQualityDocument.entity.vendorNameEn',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purchaser',
        label: 'label.sith.quality.sithMesQualityDocument.entity.purchaser',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'remark',
        label: 'label.sith.quality.sithMesQualityDocument.entity.remark',
        sortable: true,
        disabled: false,
        form: {
            type: 'textarea',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'qualityAttachmentList',
        label: 'label.sith.quality.sithMesQualityDocument.entity.qualityAttachment',
        sortable: false,
        disabled: false,
        form: {
            type: 'emAttachment',
            modalMultiSelectedType: 'string'
            , correspondingField: 'qualityAttachment'
        }
    },
    {
        key: 'qualityFiles',
        label: 'label.sith.quality.sithMesQualityDocument.entity.qualityFileIds',
        sortable: false,
        disabled: false,
        form: {
            type: 'emAttachment',
            modalMultiSelectedType: 'string'
            , correspondingField: 'qualityFileIds'
        }
    }
]

export {
    SithMesQualityDocument, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
    , filterConfigs


}
